
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Teleport from '@xt/client/mixins/components/teleport.vue'
import { EnumLogoutType } from '@xt/client/enums'

import Account from './Account.vue'
import Notice from './Notice.vue'
import Auth from './Auth.vue'
import Condition from './Condition.vue'
import Abandon from './Abandon.vue'

import type { ICheckUserInfoResp } from '@xt/client/entities/my-v2/types.d'

@Observer
@Component({
  components: {
    Teleport,
    Auth,
    Condition,
    Notice,
    Account,
    Abandon
  }
})
export default class RevokeAccountModal extends Vue {
  @Prop({}) show: boolean
  @Prop() checkUserInfo: ICheckUserInfoResp

  get PageStore() {
    return this.$store.$storeUser
  }
  get EnumLogoutType() {
    return EnumLogoutType
  }

  isView(title: 'notice' | 'condition' | 'auth' | 'account' | 'abandon') {
    return title === this.PageStore.logoutModalTitle
  }

  @Emit('onHide')
  hide() {}

  clickModel() {}

  @Watch('show')
  changeShow(value: boolean) {
    if (value) {
      document.body.style.height = '100%'
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.height = 'auto'
      document.body.style.overflow = 'auto'
    }
  }
}
